import React from "react";
import { Alert, Header, Breadcrumb, ImageCard } from "../../Components";
import { MOCK_DATA } from "../../Config/mock-data";
import { GLOBAL } from "../../Config/global";

const FormSuccess = () => {
  const { COMPONENTS_FORM, FORM_SUCCESS } = GLOBAL;
  const { MASTER_PAGE: MASTER_DATA } = MOCK_DATA;

  return (
    <section>
      <Header showBackButton={false} showHamburgerMenu showNavbar />
      <section className="form form-container mb-5">
        <div className="container">
          <div className="row">
            <div className="col-12 mt-3 mb-2">
              <Breadcrumb currentPage="/form" />
            </div>
          </div>
          <div className="row mb-2 mt-4">
            <div className="col-12">
              <Alert
                type="success"
                icon="check"
                title={COMPONENTS_FORM.ALERT_SUCCESS_TITLE}
                message={COMPONENTS_FORM.ALERT_SUCCESS_MSG}
              />
              <h1 className="form-success-title">
                {FORM_SUCCESS.TITLE}
              </h1>
              <div className="row mb-5">
                <div className="col-md-5">
                  {FORM_SUCCESS.SUBTITLE}
                </div>
              </div>
              <div className="row">
                {MASTER_DATA.infoCards.map(items => (
                  <div className="col-md-4 text-center" key={items.title}>
                    <ImageCard {...items} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*<Footer rol={USER_OPTIONS.ROLE} />*/}
    </section>
  );
};

export default FormSuccess;
